import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
import Orders from "../../order/orders/orders.jsx";
import Post_content from '../../community/content/Blog_posts.jsx';
const Coin_home = () => {
    const { slug_1 } = useParams();
    return (
        <>
            <Orders category_main='review_app' />
        </>
    );
}

export default Coin_home;
